__turbopack_context__.v({
  "className": "poppins_2e147d4e-module__Fh5IrW__className",
  "variable": "poppins_2e147d4e-module__Fh5IrW__variable",
});
